import React, { useCallback, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Btn, H4 } from '../../../AbstractElements';
import { Link } from 'react-router-dom';

export const roomsColumns = [
  {
    name: 'Name',
    selector: (row) => row['name'],
    sortable: true,
    center: false,
  },
  {
    name: 'Type of room',
    selector: (row) => row['type_of_room'],
    sortable: true,
    center: false,
  },
  {
    name: 'Hotel',
    selector: (row) => row['hotel'],
    sortable: true,
    center: false,
  },
  {
    name: 'Created at',
    selector: (row) => `${row.created_at}`,
    sortable: true,
    center: true,
  },
  {
    name: 'Actions',
    selector: (row) => row['actions'],
    sortable: false,
    center: true,
    width: '240px',
  },
];

export const roomsData = [
  {
    id: 1,
    name: 'Room 1',
    type_of_room: 'Single',
    hotel: 'Hotel 1',
    created_at: '2023/04/27',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/rooms/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
  {
    id: 2,
    name: 'Room 2',
    type_of_room: 'Dopio',
    hotel: 'Hotel 1',
    created_at: '2023/04/27',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/rooms/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
  {
    id: 3,
    name: 'Room 3',
    type_of_room: 'Suite',
    hotel: 'Hotel 1',
    created_at: '2023/04/27',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/rooms/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
];

const RoomsTable = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelete, setToggleDelet] = useState(false);
  const [data, setData] = useState(roomsData);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map((r) => r.title)}?`)) {
      setToggleDelet(!toggleDelete);

      setData(
        data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length <= 0)
      );
      setSelectedRows('');
    }
  };
  return (
    <>
      {selectedRows.length !== 0 && (
        <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
          <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data..!</H4>
          <Btn color="danger" onClick={handleDelete}>
            Delete
          </Btn>
        </div>
      )}
      <DataTable
        data={data}
        columns={roomsColumns}
        striped={true}
        center={true}
        pagination
        selectableRows
        onSelectedRowsChange={handleRowSelected}
        clearSelectedRows={toggleDelete}
      />
    </>
  );
};
export default RoomsTable;
